import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA } from '../../../constantes/permissao.constants';
import {ArquivoIpd, LabelTipoConteudoIpd,TipoConsultaImpedimento as TipoConteudoIpd } from '../../../model/arquivo.model';
import Utils from '../../../shared/fgi-utils';
import { PermissaoService } from '../../../shared/permissao.service';
import { RemoverAlertasService } from '../../../shared/services/remover-alertas.service';
import {
  OperacaoCreditoLivre,
  loteOperacoesExemploFGSEBRAE
} from '../../../model/operacao-credito-livre.model';


import { FileUtilsService } from '../../../shared/file-utils.service';
import { OcorrenciaValidacaoVO } from '../../../shared/ocorrencia-validacao.vo';
import { ModalidadeService } from '../../../shared/services/modalidade.service';
import { ProtocoloArquivoIpdService } from '../../services/protocolo-arquivo-ipd.service';

import { loteCertidaoCADIN } from '../../../model/consulta-ipd-json.model';


@Component({
  selector: 'app-importacao-lote-ipd',
  templateUrl: './importacao-lote-ipd.component.html',
  styleUrls: ['./importacao-lote-ipd.component.scss'],
 standalone: false


})
export class ImportacaoLoteIpdComponent implements OnInit {

  @ViewChild(BnConfirmDirective, {static: false}) bnConfirm?: BnConfirmDirective;

  loteOperacoesForm?: UntypedFormGroup;

  arquivo?: ArquivoIpd;
  labelTipoConteudo?: string;
  filecontentTemplate = '';

  private modalidadeGarantia?: string; // PEAC ou FGE

  private nomeModalidade?: string; // FGI PEAC, etc.

  private enviado?: boolean;

  private ocorrencias: OcorrenciaValidacaoVO[] = [];

  private operacoes: OperacaoCreditoLivre[] = [];

  private cnpjUsuario?: string;

  private isAgente?: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: ProtocoloArquivoIpdService,
    private router: Router,
    private bnAlertsService: BnAlertsService,
    private fileUtils: FileUtilsService,
    private messageService: MessageChannelService,
    private bnUsuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private removerAlertasService: RemoverAlertasService,
    private loadingService: BnLoadingService,
    private modalidadeService: ModalidadeService) {
  }

  ngOnInit() {
    this.createReactiveForm();

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario?.cnpj;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.modalidadeService.modalidade$.subscribe((mod) =>{
      this.modalidadeGarantia = mod;
      for (let modalidade of this.modalidadeService.getModalidades()) {
        if (modalidade.sigla == mod) {
          this.nomeModalidade = modalidade.nome;
        }
      }
  })

  }

   createReactiveForm() {
    this.loteOperacoesForm = this.formBuilder.group({
      arquivo: ['', Validators.required]
    });
  }

  baixarExemploCertidao() {

    let conteudoArquivoExemplo!: string;

    switch (this.modalidadeGarantia){

      case 'FGBS':
        conteudoArquivoExemplo = loteCertidaoCADIN
          .replace("##MODALIDADE_GARANTIA##", this.modalidadeGarantia);
        break;

    }

    this.fileUtils.exportarArquivo('exemplo-importacao-cnpjs.json',
         this.trocaAgenteLogado(conteudoArquivoExemplo), FileUtilsService.APPLICATION_JSON);
  }



  private trocaAgenteLogado(exemploStr): string {
    if (!this.isAgente) {
      return exemploStr;
    }
    const exemplo = JSON.parse(exemploStr);
    for (const operacao of exemplo.cnpj) {

    }
    return JSON.stringify(exemplo, null, 2);
  }

  private trocaAgenteLogadoAmortizacoes(exemploStr): string {
      if (!this.isAgente) {
          return exemploStr;
      }

      const exemplo = JSON.parse(exemploStr);
      exemplo.cnpjAgenteFinanceiro = this.cnpjUsuario;
      return JSON.stringify(exemplo, null, 2);
  }

  onFileChange(event) {
    let marcador = new MarcadorTempo("onFileChange");
    this.operacoes = [];
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    this.loteOperacoesForm.markAsDirty();
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      if (!this.suportaTamArquivo(file.size)) {
        console.log(`Arquivo muito grande ${file.size} bytes`);
        // A mensagem abaixo não aparece se for chamada diretamente aqui
        // Acredito (jmaur) que é por esta em tratamento de evento
        // Colocá-la em um processamento assíncrono (como o setTimeout()) resolve a questão
        setTimeout(() => {
          this.limpar();
          this.bnAlertsService.alertaErro('Erro', `O arquivo ${file.name} é muito grande. Divida em lotes menores e envie um arquivo por vez.`);
        }, 0);
        return;
      }
      marcador.marcaTempo("inicio");

      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        marcador.marcaTempo("readAsText");

        let conteudoArquivo: string = '';
        if (typeof reader.result === 'string') {
          conteudoArquivo = reader.result;
        } else {
          conteudoArquivo = this.fileUtils.lerConteudo(reader);
        }
        marcador.marcaTempo("lerConteudo");

        // evitar erros com estas aspas estranhas
        conteudoArquivo = conteudoArquivo.replace('“', '"').replace('”', '"');
        marcador.marcaTempo("replace");

        const lote = this.validarArquivo(file.name, file.type, conteudoArquivo);
        marcador.marcaTempo("validarArquivo");
        if (!lote) {
                    return;
        }


        this.arquivo = new ArquivoIpd();
        this.arquivo.filename = file.name;
        this.arquivo.filetype = file.type;
        this.arquivo.value = conteudoArquivo;
        this.arquivo.tipoConteudo = lote.tipoConteudo;
        this.labelTipoConteudo = LabelTipoConteudoIpd.get(this.arquivo.tipoConteudo);

        this.loteOperacoesForm.updateValueAndValidity();
        marcador.marcaTempo("updateValueAndValidity");
      };
    }
  }

  onSubmit() {

    if (!this.arquivo.value) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não possui conteúdo.');
      return;
    }

    this.loteOperacoesForm.disable();
    this.enviado = true;
    this.enviarOperacoes();
  }

  enviarOperacoes() {
      this.loadingService.bloqueiaTela();

      this.operacoes = [];
      this.ocorrencias = [];

      let marcador = new MarcadorTempo("enviarOperacoes");

      const msgService = this.messageService;
      const loteOperacoes = JSON.parse(this.arquivo.value);
      marcador.marcaTempo("parse");

      let totalItens = 0;

      // preenche a data de envio

      if (this.arquivo.tipoConteudo === TipoConteudoIpd.IMPORTACAO_CERTIDAO_CADIN) {

        this.operacoes = loteOperacoes.cnpj;
        totalItens = this.operacoes.length;
      }

      marcador.marcaTempo("forEach-datas");

      const exibirMensagemSucesso = (res) => {
        this.loadingService.liberaTela();
        if (this.arquivo.tipoConteudo == TipoConteudoIpd.IMPORTACAO_CERTIDAO_CADIN) {
          const mensagemSucesso = `${res.mensagem} Id de protocolo: ${res.idProtocolo}`;
          msgService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: mensagemSucesso
          });
          this.router.navigate(['/operacoes/ipd']);
        }
        else {
          this.operacoes = res;
          msgService.addMessage(this.gerarMensagemSucesso(this.arquivo.tipoConteudo, totalItens));
        }
        this.limpar();
      };

      const exibirMensagemErro = (err) => {
              this.loadingService.liberaTela();
        this.ocorrencias = this.service.ocorrencias;
        this.limpar();
      };

      if (this.arquivo.tipoConteudo === TipoConteudoIpd.IMPORTACAO_CERTIDAO_CADIN) {
        this.service.enviarLoteCnpjs(loteOperacoes).subscribe(exibirMensagemSucesso, exibirMensagemErro);
      }
    }

  private gerarMensagemSucesso(tipoConteudo: TipoConteudoIpd, totalItens) {

    let msgSucesso: string;

    const descricaoConteudo = LabelTipoConteudoIpd.get(tipoConteudo);

    if (this.loteOperacoesForm.get('opcaoEnvio').value === 'validar') {
      msgSucesso = `Todas as ${descricaoConteudo} são enquadráveis ao FGI PEAC neste instante.`;
    } else {
      msgSucesso = `Todas as ${descricaoConteudo} foram enviadas com sucesso.`;
    }

    msgSucesso += ` Total de ${descricaoConteudo}: ${totalItens}`;

    return {
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: msgSucesso
    };
  }

  private validarArquivo(nomeArquivo, tipoArquivo, conteudoArquivo): Lote {
    if (tipoArquivo !== 'application/json') {
      this.bnAlertsService.alertaErro('Erro', `O sistema suporta apenas arquivos JSON - '${nomeArquivo}' --> '${tipoArquivo}'.`);
      this.limpar();
      return null;
    }
    if (conteudoArquivo === null || conteudoArquivo === '') {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo está vazio.');
      this.limpar();
      return null;
    }

    if (!Utils.isValidJson(conteudoArquivo)) {
      this.bnAlertsService.alertaErro('Erro', 'Não foi possível validar o arquivo JSON. ' +
        'Verifique se há erros de sintaxe no arquivo, como vírgulas mal colocadas ou chaves não fechadas. ' +
        'Uma sugestão é utilizar um dos vários sites de validação JSON disponíveis na web.');
      this.limpar();
      return null;
    }

    const conteudo = JSON.parse(conteudoArquivo);

    const lote = FabricaLote.criar(conteudo);

    if (lote === null) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não possui CNPJS.');
      this.limpar();
      return null;
    }

    const erro = lote.validar();
    if (erro !== null) {
        this.bnAlertsService.alertaErro('Erro', erro);
        this.limpar();
        return null;
    }

    return lote;
  }

  canDeactivate(): Observable<boolean> | boolean {
    console.log("this.enviado",this.enviado);

    if (this.enviado || this.loteOperacoesForm.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  verificaSePodeSair(): Observable<string> {
    this.bnConfirm.abrirModal();
    return this.bnConfirm.resultadoConfirm.asObservable();
  }

  baixarTabelaDeErros() {
    const ocorrenciasJson = JSON.stringify(this.ocorrencias);
    this.fileUtils.exportarArquivo('erros.json', ocorrenciasJson, FileUtilsService.APPLICATION_JSON);
  }

  ajustaDatas(): (key: any, obj: any) => any {
    let dateTimeFields:any = {};
    dateTimeFields.dataEnvio = "DateTime";
    dateTimeFields.dataReferenciaProtocolo = "Date";
    dateTimeFields.dataContratacao = "Date";
    dateTimeFields.dataReferenciaReceitaBruta = "Date";
    dateTimeFields.dataPrimeiraLiberacao = "Date";
    dateTimeFields.data = "Date";

    return ((key, obj) => {
      if (!dateTimeFields[key]) {
        return obj;
      }

      if (dateTimeFields[key] === "Date") {
        return moment(obj).format("YYYY-MM-DD");
      }

      if (dateTimeFields[key] === "DateTime") {
        return moment(obj).format("YYYY-MM-DDTHH:mm:ss.SSS");
      }

      // Não deve ter sobrado nada para cá
      return obj;
    })
  }

  tiposConteudo() {
    return TipoConteudoIpd;
  }

  limpar() {
    this.arquivo = null;

    this.loteOperacoesForm.reset();
    this.loteOperacoesForm.markAsPristine();
    this.loteOperacoesForm.enable();
    this.loteOperacoesForm.updateValueAndValidity();

    this.enviado = false;
  }

  voltar() {
    this.router.navigate(['/operacoes/ipd']);
  }

  private suportaTamArquivo(fileSizeBytes: number): boolean {
    // tenta descobrir o quanto temos de memória
    let memSizeBytes = undefined;
    let perf: any = window.performance;
    if (perf.memory) {
      memSizeBytes = perf.memory.jsHeapSizeLimit;
    }

    if (memSizeBytes) {
      const limiteBytes = Math.round(memSizeBytes / 30); // Número mágico, apurado com algumas medições
      console.log(`limiteArquivo - estimado pela memória livre. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    } else {
      const limiteBytes = 64 * 1024 * 1024; // 64 MB deve caber em uma máquina com 8GB
      console.log(`limiteArquivo - valor fixo. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    }
  }
}

class MarcadorTempo {
  private timestamp = Date.now();

  constructor(private nome:string) {}

  public inicia(): void {
    this.timestamp = Date.now();
  }

  public marcaTempo(msg: string): void {
    console.log(`[${this.nome}] ${msg} -`, (Date.now() - this.timestamp));
    this.inicia();
  }
}

abstract class Lote {
  conteudo: any;

  constructor(public tipoConteudo: TipoConteudoIpd, conteudo: any) {
    this.conteudo = conteudo;
  };

  abstract validar();
}

class LoteCertidaoCadin extends Lote {
  constructor(conteudo: any) {
    super(TipoConteudoIpd.IMPORTACAO_CERTIDAO_CADIN, conteudo);
  };

  validar() {

    if (!this.conteudo || !this.conteudo.cnpj) {

      return 'Arquivo inválido: objeto "cnpj" não encontrado';
    }

    return null;
  }
}

class FabricaLote {

  static criar(conteudo: any): Lote {
    console.log(conteudo)
    if(conteudo.cnpj) {
      return new LoteCertidaoCadin(conteudo);
    }else {
      return null;
    }
  }
}
